/**
 * @export
 */
export const AbstractWebhookPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const AccountDtoAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const AddPhoneNumberOptionsPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const AddPhonePlanOptionsPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const AddonSupportDtoSupportedPlansEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const AddonSupportDtoDisabledPlansEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const AutomationMetricsStatusEnum = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    INFO: 'INFO'
};
/**
 * @export
 */
export const AutomationMetricsStateEnum = {
    OKAY: 'OKAY',
    HAS_WEBHOOK_ERRORS: 'HAS_WEBHOOK_ERRORS'
};
/**
 * @export
 */
export const CanResultLimitTypeEnum = {
    MONTHLY_COUNT: 'MONTHLY_COUNT',
    TOTAL_EXISTING: 'TOTAL_EXISTING',
    FEATURE_TOGGLE: 'FEATURE_TOGGLE'
};
/**
 * @export
 */
export const ConditionOptionConditionEnum = {
    HAS_ATTACHMENTS: 'HAS_ATTACHMENTS'
};
/**
 * @export
 */
export const ConditionOptionValueEnum = {
    TRUE: 'TRUE',
    FALSE: 'FALSE'
};
/**
 * @export
 */
export const ConnectorEventDtoStatusEnum = {
    SUCCESS: 'SUCCESS',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SUBSCRIPTION_ERROR: 'SUBSCRIPTION_ERROR',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    NOT_FOUND: 'NOT_FOUND'
};
/**
 * @export
 */
export const ConnectorEventDtoEventTypeEnum = {
    SEND: 'SEND',
    SYNC: 'SYNC'
};
/**
 * @export
 */
export const ConnectorEventProjectionEventTypeEnum = {
    SEND: 'SEND',
    SYNC: 'SYNC'
};
/**
 * @export
 */
export const ConnectorEventProjectionStatusEnum = {
    SUCCESS: 'SUCCESS',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SUBSCRIPTION_ERROR: 'SUBSCRIPTION_ERROR',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    NOT_FOUND: 'NOT_FOUND'
};
/**
 * @export
 */
export const ConnectorSyncSettingsDtoSyncScheduleTypeEnum = {
    INTERVAL: 'INTERVAL'
};
/**
 * @export
 */
export const CreateConnectorSyncSettingsOptionsSyncScheduleTypeEnum = {
    INTERVAL: 'INTERVAL'
};
/**
 * @export
 */
export const CreateDomainOptionsDomainTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_DOMAIN: 'SMTP_DOMAIN'
};
/**
 * @export
 */
export const CreateEmergencyAddressOptionsIsoCountryCodeEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const CreateInboxDtoInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const CreateInboxForwarderOptionsFieldEnum = {
    RECIPIENTS: 'RECIPIENTS',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
    ATTACHMENTS: 'ATTACHMENTS'
};
/**
 * @export
 */
export const CreateInboxReplierOptionsFieldEnum = {
    RECIPIENTS: 'RECIPIENTS',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
    ATTACHMENTS: 'ATTACHMENTS'
};
/**
 * @export
 */
export const CreateInboxRulesetOptionsScopeEnum = {
    RECEIVING_EMAILS: 'RECEIVING_EMAILS',
    SENDING_EMAILS: 'SENDING_EMAILS'
};
/**
 * @export
 */
export const CreateInboxRulesetOptionsActionEnum = {
    BLOCK: 'BLOCK',
    ALLOW: 'ALLOW',
    FILTER_REMOVE: 'FILTER_REMOVE'
};
/**
 * @export
 */
export const CreateOnboardingSubmissionOptionsTeamSizeEnum = {
    SOLO: 'SOLO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const CreateOrganizationSamlSettingsOptionsSignatureAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const CreateOrganizationSamlSettingsOptionsDigestAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const CreateOrganizationSamlSettingsOptionsProtocolEnum = {
    HTTP: 'HTTP',
    HTTPS: 'HTTPS'
};
/**
 * @export
 */
export const CreateOrganizationSamlSettingsOptionsAuthnRequestBindingEnum = {
    REDIRECT: 'HTTP_REDIRECT',
    POST: 'HTTP_POST'
};
/**
 * @export
 */
export const CreateSubscriptionEndedOptionsEndedSourceEnum = {
    USER_DASHBOARD_REQUEST: 'USER_DASHBOARD_REQUEST',
    STRIPE_WEBHOOK: 'STRIPE_WEBHOOK',
    CRON_JOB_ORPHAN: 'CRON_JOB_ORPHAN',
    CRON_JOB_USER_FROZEN: 'CRON_JOB_USER_FROZEN',
    CRON_JOB_CLOSE_FROZEN: 'CRON_JOB_CLOSE_FROZEN',
    UPGRADE_STEP: 'UPGRADE_STEP'
};
/**
 * @export
 */
export const CreateTemporaryAccessKeyOptionsEndpointEnum = {
    GET_EMAIL: 'GET_EMAIL',
    GET_ATTACHMENT: 'GET_ATTACHMENT',
    ALL: 'ALL'
};
/**
 * @export
 */
export const CreateTestUserOptionsSubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const CreateTestUserOptionsPhonePlanCountriesEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const CreateTestUserOptionsVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const CreateUpgradeSessionWithSuggestedPlanForExtrasDesiredPhonePlanCountriesEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const CreateUpgradeSessionWithSuggestedPlanForExtrasDesiredAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const CreateWebhookOptionsEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const DNSLookupOptionsRecordTypesEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const DNSLookupResultRecordTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const DomainDtoDomainTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_DOMAIN: 'SMTP_DOMAIN'
};
/**
 * @export
 */
export const DomainGroupLabelEnum = {
    DEFAULT: 'DEFAULT',
    DOMAIN_POOL: 'DOMAIN_POOL',
    CUSTOM: 'CUSTOM'
};
/**
 * @export
 */
export const DomainInformationDomainTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_DOMAIN: 'SMTP_DOMAIN'
};
/**
 * @export
 */
export const DomainNameRecordLabelEnum = {
    VERIFICATION: 'VERIFICATION',
    MX: 'MX',
    SPF: 'SPF',
    DKIM: 'DKIM',
    DMARC: 'DMARC'
};
/**
 * @export
 */
export const DomainNameRecordRecordTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const DomainPreviewDomainTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_DOMAIN: 'SMTP_DOMAIN'
};
/**
 * @export
 */
export const EmailFeatureCategoryNameSlugEnum = {
    css: 'css',
    html: 'html',
    image: 'image',
    others: 'others'
};
/**
 * @export
 */
export const EmailFeatureFamilyNameSlugEnum = {
    aol: 'aol',
    apple_mail: 'apple-mail',
    fastmail: 'fastmail',
    free_fr: 'free-fr',
    gmail: 'gmail',
    gmx: 'gmx',
    hey: 'hey',
    ionos_1and1: 'ionos-1and1',
    laposte: 'laposte',
    mail_ru: 'mail-ru',
    microsoft: 'microsoft',
    orange: 'orange',
    outlook: 'outlook',
    protonmail: 'protonmail',
    rainloop: 'rainloop',
    samsung_email: 'samsung-email',
    sfr: 'sfr',
    t_online_de: 't-online-de',
    thunderbird: 'thunderbird',
    web_de: 'web-de',
    yahoo: 'yahoo'
};
/**
 * @export
 */
export const EmailFeatureFamilyStatisticsFeatureEnum = {
    amp: 'amp',
    css_accent_color: 'css-accent-color',
    css_align_items: 'css-align-items',
    css_animation: 'css-animation',
    css_aspect_ratio: 'css-aspect-ratio',
    css_at_font_face: 'css-at-font-face',
    css_at_import: 'css-at-import',
    css_at_keyframes: 'css-at-keyframes',
    css_at_media: 'css-at-media',
    css_at_supports: 'css-at-supports',
    css_background_blend_mode: 'css-background-blend-mode',
    css_background_clip: 'css-background-clip',
    css_background_color: 'css-background-color',
    css_background_image: 'css-background-image',
    css_background_origin: 'css-background-origin',
    css_background_position: 'css-background-position',
    css_background_repeat: 'css-background-repeat',
    css_background_size: 'css-background-size',
    css_background: 'css-background',
    css_block_inline_size: 'css-block-inline-size',
    css_border_image: 'css-border-image',
    css_border_inline_block_individual: 'css-border-inline-block-individual',
    css_border_inline_block_longhand: 'css-border-inline-block-longhand',
    css_border_inline_block: 'css-border-inline-block',
    css_border_radius_logical: 'css-border-radius-logical',
    css_border_radius: 'css-border-radius',
    css_border: 'css-border',
    css_box_shadow: 'css-box-shadow',
    css_box_sizing: 'css-box-sizing',
    css_caption_side: 'css-caption-side',
    css_clip_path: 'css-clip-path',
    css_column_count: 'css-column-count',
    css_column_layout_properties: 'css-column-layout-properties',
    css_direction: 'css-direction',
    css_display_flex: 'css-display-flex',
    css_display_grid: 'css-display-grid',
    css_display_none: 'css-display-none',
    css_display: 'css-display',
    css_filter: 'css-filter',
    css_flex_direction: 'css-flex-direction',
    css_flex_wrap: 'css-flex-wrap',
    css_float: 'css-float',
    css_font_kerning: 'css-font-kerning',
    css_font_weight: 'css-font-weight',
    css_font: 'css-font',
    css_gap: 'css-gap',
    css_grid_template: 'css-grid-template',
    css_height: 'css-height',
    css_hyphens: 'css-hyphens',
    css_inline_size: 'css-inline-size',
    css_justify_content: 'css-justify-content',
    css_left_right_top_bottom: 'css-left-right-top-bottom',
    css_letter_spacing: 'css-letter-spacing',
    css_line_height: 'css-line-height',
    css_list_style_image: 'css-list-style-image',
    css_list_style_position: 'css-list-style-position',
    css_list_style_type: 'css-list-style-type',
    css_list_style: 'css-list-style',
    css_margin_block_start_end: 'css-margin-block-start-end',
    css_margin_inline_block: 'css-margin-inline-block',
    css_margin_inline_start_end: 'css-margin-inline-start-end',
    css_margin_inline: 'css-margin-inline',
    css_margin: 'css-margin',
    css_max_block_size: 'css-max-block-size',
    css_max_height: 'css-max-height',
    css_max_width: 'css-max-width',
    css_min_height: 'css-min-height',
    css_min_inline_size: 'css-min-inline-size',
    css_min_width: 'css-min-width',
    css_mix_blend_mode: 'css-mix-blend-mode',
    css_object_fit: 'css-object-fit',
    css_object_position: 'css-object-position',
    css_opacity: 'css-opacity',
    css_outline_offset: 'css-outline-offset',
    css_outline: 'css-outline',
    css_overflow_wrap: 'css-overflow-wrap',
    css_overflow: 'css-overflow',
    css_padding_block_start_end: 'css-padding-block-start-end',
    css_padding_inline_block: 'css-padding-inline-block',
    css_padding_inline_start_end: 'css-padding-inline-start-end',
    css_padding: 'css-padding',
    css_position: 'css-position',
    css_tab_size: 'css-tab-size',
    css_table_layout: 'css-table-layout',
    css_text_align_last: 'css-text-align-last',
    css_text_align: 'css-text-align',
    css_text_decoration_color: 'css-text-decoration-color',
    css_text_decoration_thickness: 'css-text-decoration-thickness',
    css_text_decoration: 'css-text-decoration',
    css_text_emphasis_position: 'css-text-emphasis-position',
    css_text_emphasis: 'css-text-emphasis',
    css_text_indent: 'css-text-indent',
    css_text_overflow: 'css-text-overflow',
    css_text_shadow: 'css-text-shadow',
    css_text_transform: 'css-text-transform',
    css_text_underline_offset: 'css-text-underline-offset',
    css_transform: 'css-transform',
    css_vertical_align: 'css-vertical-align',
    css_visibility: 'css-visibility',
    css_white_space: 'css-white-space',
    css_width: 'css-width',
    css_word_break: 'css-word-break',
    css_writing_mode: 'css-writing-mode',
    css_z_index: 'css-z-index',
    html_abbr: 'html-abbr',
    html_address: 'html-address',
    html_align: 'html-align',
    html_anchor_links: 'html-anchor-links',
    html_aria_describedby: 'html-aria-describedby',
    html_aria_hidden: 'html-aria-hidden',
    html_aria_label: 'html-aria-label',
    html_aria_labelledby: 'html-aria-labelledby',
    html_aria_live: 'html-aria-live',
    html_audio: 'html-audio',
    html_background: 'html-background',
    html_base: 'html-base',
    html_blockquote: 'html-blockquote',
    html_body: 'html-body',
    html_button_reset: 'html-button-reset',
    html_button_submit: 'html-button-submit',
    html_code: 'html-code',
    html_del: 'html-del',
    html_dfn: 'html-dfn',
    html_dialog: 'html-dialog',
    html_dir: 'html-dir',
    html_div: 'html-div',
    html_doctype: 'html-doctype',
    html_form: 'html-form',
    html_h1_h6: 'html-h1-h6',
    html_height: 'html-height',
    html_image_maps: 'html-image-maps',
    html_input_checkbox: 'html-input-checkbox',
    html_input_hidden: 'html-input-hidden',
    html_input_radio: 'html-input-radio',
    html_input_reset: 'html-input-reset',
    html_input_submit: 'html-input-submit',
    html_input_text: 'html-input-text',
    html_lang: 'html-lang',
    html_link: 'html-link',
    html_lists: 'html-lists',
    html_loading_attribute: 'html-loading-attribute',
    html_mailto_links: 'html-mailto-links',
    html_marquee: 'html-marquee',
    html_meter: 'html-meter',
    html_object: 'html-object',
    html_p: 'html-p',
    html_picture: 'html-picture',
    html_pre: 'html-pre',
    html_progress: 'html-progress',
    html_required: 'html-required',
    html_role: 'html-role',
    html_rp: 'html-rp',
    html_rt: 'html-rt',
    html_ruby: 'html-ruby',
    html_select: 'html-select',
    html_semantics: 'html-semantics',
    html_small: 'html-small',
    html_span: 'html-span',
    html_srcset: 'html-srcset',
    html_strike: 'html-strike',
    html_strong: 'html-strong',
    html_style: 'html-style',
    html_svg: 'html-svg',
    html_table: 'html-table',
    html_target: 'html-target',
    html_textarea: 'html-textarea',
    html_valign: 'html-valign',
    html_video: 'html-video',
    html_wbr: 'html-wbr',
    html_width: 'html-width',
    image_avif: 'image-avif',
    image_base64: 'image-base64',
    image_bmp: 'image-bmp',
    image_gif: 'image-gif',
    image_ico: 'image-ico',
    image_jpg: 'image-jpg',
    image_png: 'image-png',
    image_svg: 'image-svg',
    image_webp: 'image-webp',
    unsupported: 'unsupported'
};
/**
 * @export
 */
export const EmailFeatureFamilyStatisticsFamilyEnum = {
    aol: 'aol',
    apple_mail: 'apple-mail',
    fastmail: 'fastmail',
    free_fr: 'free-fr',
    gmail: 'gmail',
    gmx: 'gmx',
    hey: 'hey',
    ionos_1and1: 'ionos-1and1',
    laposte: 'laposte',
    mail_ru: 'mail-ru',
    microsoft: 'microsoft',
    orange: 'orange',
    outlook: 'outlook',
    protonmail: 'protonmail',
    rainloop: 'rainloop',
    samsung_email: 'samsung-email',
    sfr: 'sfr',
    t_online_de: 't-online-de',
    thunderbird: 'thunderbird',
    web_de: 'web-de',
    yahoo: 'yahoo'
};
/**
 * @export
 */
export const EmailFeatureOverviewFeatureEnum = {
    amp: 'amp',
    css_accent_color: 'css-accent-color',
    css_align_items: 'css-align-items',
    css_animation: 'css-animation',
    css_aspect_ratio: 'css-aspect-ratio',
    css_at_font_face: 'css-at-font-face',
    css_at_import: 'css-at-import',
    css_at_keyframes: 'css-at-keyframes',
    css_at_media: 'css-at-media',
    css_at_supports: 'css-at-supports',
    css_background_blend_mode: 'css-background-blend-mode',
    css_background_clip: 'css-background-clip',
    css_background_color: 'css-background-color',
    css_background_image: 'css-background-image',
    css_background_origin: 'css-background-origin',
    css_background_position: 'css-background-position',
    css_background_repeat: 'css-background-repeat',
    css_background_size: 'css-background-size',
    css_background: 'css-background',
    css_block_inline_size: 'css-block-inline-size',
    css_border_image: 'css-border-image',
    css_border_inline_block_individual: 'css-border-inline-block-individual',
    css_border_inline_block_longhand: 'css-border-inline-block-longhand',
    css_border_inline_block: 'css-border-inline-block',
    css_border_radius_logical: 'css-border-radius-logical',
    css_border_radius: 'css-border-radius',
    css_border: 'css-border',
    css_box_shadow: 'css-box-shadow',
    css_box_sizing: 'css-box-sizing',
    css_caption_side: 'css-caption-side',
    css_clip_path: 'css-clip-path',
    css_column_count: 'css-column-count',
    css_column_layout_properties: 'css-column-layout-properties',
    css_direction: 'css-direction',
    css_display_flex: 'css-display-flex',
    css_display_grid: 'css-display-grid',
    css_display_none: 'css-display-none',
    css_display: 'css-display',
    css_filter: 'css-filter',
    css_flex_direction: 'css-flex-direction',
    css_flex_wrap: 'css-flex-wrap',
    css_float: 'css-float',
    css_font_kerning: 'css-font-kerning',
    css_font_weight: 'css-font-weight',
    css_font: 'css-font',
    css_gap: 'css-gap',
    css_grid_template: 'css-grid-template',
    css_height: 'css-height',
    css_hyphens: 'css-hyphens',
    css_inline_size: 'css-inline-size',
    css_justify_content: 'css-justify-content',
    css_left_right_top_bottom: 'css-left-right-top-bottom',
    css_letter_spacing: 'css-letter-spacing',
    css_line_height: 'css-line-height',
    css_list_style_image: 'css-list-style-image',
    css_list_style_position: 'css-list-style-position',
    css_list_style_type: 'css-list-style-type',
    css_list_style: 'css-list-style',
    css_margin_block_start_end: 'css-margin-block-start-end',
    css_margin_inline_block: 'css-margin-inline-block',
    css_margin_inline_start_end: 'css-margin-inline-start-end',
    css_margin_inline: 'css-margin-inline',
    css_margin: 'css-margin',
    css_max_block_size: 'css-max-block-size',
    css_max_height: 'css-max-height',
    css_max_width: 'css-max-width',
    css_min_height: 'css-min-height',
    css_min_inline_size: 'css-min-inline-size',
    css_min_width: 'css-min-width',
    css_mix_blend_mode: 'css-mix-blend-mode',
    css_object_fit: 'css-object-fit',
    css_object_position: 'css-object-position',
    css_opacity: 'css-opacity',
    css_outline_offset: 'css-outline-offset',
    css_outline: 'css-outline',
    css_overflow_wrap: 'css-overflow-wrap',
    css_overflow: 'css-overflow',
    css_padding_block_start_end: 'css-padding-block-start-end',
    css_padding_inline_block: 'css-padding-inline-block',
    css_padding_inline_start_end: 'css-padding-inline-start-end',
    css_padding: 'css-padding',
    css_position: 'css-position',
    css_tab_size: 'css-tab-size',
    css_table_layout: 'css-table-layout',
    css_text_align_last: 'css-text-align-last',
    css_text_align: 'css-text-align',
    css_text_decoration_color: 'css-text-decoration-color',
    css_text_decoration_thickness: 'css-text-decoration-thickness',
    css_text_decoration: 'css-text-decoration',
    css_text_emphasis_position: 'css-text-emphasis-position',
    css_text_emphasis: 'css-text-emphasis',
    css_text_indent: 'css-text-indent',
    css_text_overflow: 'css-text-overflow',
    css_text_shadow: 'css-text-shadow',
    css_text_transform: 'css-text-transform',
    css_text_underline_offset: 'css-text-underline-offset',
    css_transform: 'css-transform',
    css_vertical_align: 'css-vertical-align',
    css_visibility: 'css-visibility',
    css_white_space: 'css-white-space',
    css_width: 'css-width',
    css_word_break: 'css-word-break',
    css_writing_mode: 'css-writing-mode',
    css_z_index: 'css-z-index',
    html_abbr: 'html-abbr',
    html_address: 'html-address',
    html_align: 'html-align',
    html_anchor_links: 'html-anchor-links',
    html_aria_describedby: 'html-aria-describedby',
    html_aria_hidden: 'html-aria-hidden',
    html_aria_label: 'html-aria-label',
    html_aria_labelledby: 'html-aria-labelledby',
    html_aria_live: 'html-aria-live',
    html_audio: 'html-audio',
    html_background: 'html-background',
    html_base: 'html-base',
    html_blockquote: 'html-blockquote',
    html_body: 'html-body',
    html_button_reset: 'html-button-reset',
    html_button_submit: 'html-button-submit',
    html_code: 'html-code',
    html_del: 'html-del',
    html_dfn: 'html-dfn',
    html_dialog: 'html-dialog',
    html_dir: 'html-dir',
    html_div: 'html-div',
    html_doctype: 'html-doctype',
    html_form: 'html-form',
    html_h1_h6: 'html-h1-h6',
    html_height: 'html-height',
    html_image_maps: 'html-image-maps',
    html_input_checkbox: 'html-input-checkbox',
    html_input_hidden: 'html-input-hidden',
    html_input_radio: 'html-input-radio',
    html_input_reset: 'html-input-reset',
    html_input_submit: 'html-input-submit',
    html_input_text: 'html-input-text',
    html_lang: 'html-lang',
    html_link: 'html-link',
    html_lists: 'html-lists',
    html_loading_attribute: 'html-loading-attribute',
    html_mailto_links: 'html-mailto-links',
    html_marquee: 'html-marquee',
    html_meter: 'html-meter',
    html_object: 'html-object',
    html_p: 'html-p',
    html_picture: 'html-picture',
    html_pre: 'html-pre',
    html_progress: 'html-progress',
    html_required: 'html-required',
    html_role: 'html-role',
    html_rp: 'html-rp',
    html_rt: 'html-rt',
    html_ruby: 'html-ruby',
    html_select: 'html-select',
    html_semantics: 'html-semantics',
    html_small: 'html-small',
    html_span: 'html-span',
    html_srcset: 'html-srcset',
    html_strike: 'html-strike',
    html_strong: 'html-strong',
    html_style: 'html-style',
    html_svg: 'html-svg',
    html_table: 'html-table',
    html_target: 'html-target',
    html_textarea: 'html-textarea',
    html_valign: 'html-valign',
    html_video: 'html-video',
    html_wbr: 'html-wbr',
    html_width: 'html-width',
    image_avif: 'image-avif',
    image_base64: 'image-base64',
    image_bmp: 'image-bmp',
    image_gif: 'image-gif',
    image_ico: 'image-ico',
    image_jpg: 'image-jpg',
    image_png: 'image-png',
    image_svg: 'image-svg',
    image_webp: 'image-webp',
    unsupported: 'unsupported'
};
/**
 * @export
 */
export const EmailFeatureOverviewCategoryEnum = {
    css: 'css',
    html: 'html',
    image: 'image',
    others: 'others'
};
/**
 * @export
 */
export const EmailFeatureOverviewStatusesEnum = {
    SUPPORTED: 'SUPPORTED',
    PARTIAL: 'PARTIAL',
    NOT_SUPPORTED: 'NOT_SUPPORTED',
    UNKNOWN: 'UNKNOWN'
};
/**
 * @export
 */
export const EmailFeaturePlatformNameSlugEnum = {
    android: 'android',
    desktop_app: 'desktop-app',
    desktop_webmail: 'desktop-webmail',
    ios: 'ios',
    macos: 'macos',
    mobile_webmail: 'mobile-webmail',
    outlook_com: 'outlook-com',
    webmail: 'webmail',
    windows: 'windows',
    windows_mail: 'windows-mail'
};
/**
 * @export
 */
export const EmailFeaturePlatformStatisticsPlatformEnum = {
    android: 'android',
    desktop_app: 'desktop-app',
    desktop_webmail: 'desktop-webmail',
    ios: 'ios',
    macos: 'macos',
    mobile_webmail: 'mobile-webmail',
    outlook_com: 'outlook-com',
    webmail: 'webmail',
    windows: 'windows',
    windows_mail: 'windows-mail'
};
/**
 * @export
 */
export const EmailFeatureSupportFlagsStatusEnum = {
    SUPPORTED: 'SUPPORTED',
    PARTIAL: 'PARTIAL',
    NOT_SUPPORTED: 'NOT_SUPPORTED',
    UNKNOWN: 'UNKNOWN'
};
/**
 * @export
 */
export const EmailFeatureSupportResultDetectedFeaturesEnum = {
    amp: 'amp',
    css_accent_color: 'css-accent-color',
    css_align_items: 'css-align-items',
    css_animation: 'css-animation',
    css_aspect_ratio: 'css-aspect-ratio',
    css_at_font_face: 'css-at-font-face',
    css_at_import: 'css-at-import',
    css_at_keyframes: 'css-at-keyframes',
    css_at_media: 'css-at-media',
    css_at_supports: 'css-at-supports',
    css_background_blend_mode: 'css-background-blend-mode',
    css_background_clip: 'css-background-clip',
    css_background_color: 'css-background-color',
    css_background_image: 'css-background-image',
    css_background_origin: 'css-background-origin',
    css_background_position: 'css-background-position',
    css_background_repeat: 'css-background-repeat',
    css_background_size: 'css-background-size',
    css_background: 'css-background',
    css_block_inline_size: 'css-block-inline-size',
    css_border_image: 'css-border-image',
    css_border_inline_block_individual: 'css-border-inline-block-individual',
    css_border_inline_block_longhand: 'css-border-inline-block-longhand',
    css_border_inline_block: 'css-border-inline-block',
    css_border_radius_logical: 'css-border-radius-logical',
    css_border_radius: 'css-border-radius',
    css_border: 'css-border',
    css_box_shadow: 'css-box-shadow',
    css_box_sizing: 'css-box-sizing',
    css_caption_side: 'css-caption-side',
    css_clip_path: 'css-clip-path',
    css_column_count: 'css-column-count',
    css_column_layout_properties: 'css-column-layout-properties',
    css_direction: 'css-direction',
    css_display_flex: 'css-display-flex',
    css_display_grid: 'css-display-grid',
    css_display_none: 'css-display-none',
    css_display: 'css-display',
    css_filter: 'css-filter',
    css_flex_direction: 'css-flex-direction',
    css_flex_wrap: 'css-flex-wrap',
    css_float: 'css-float',
    css_font_kerning: 'css-font-kerning',
    css_font_weight: 'css-font-weight',
    css_font: 'css-font',
    css_gap: 'css-gap',
    css_grid_template: 'css-grid-template',
    css_height: 'css-height',
    css_hyphens: 'css-hyphens',
    css_inline_size: 'css-inline-size',
    css_justify_content: 'css-justify-content',
    css_left_right_top_bottom: 'css-left-right-top-bottom',
    css_letter_spacing: 'css-letter-spacing',
    css_line_height: 'css-line-height',
    css_list_style_image: 'css-list-style-image',
    css_list_style_position: 'css-list-style-position',
    css_list_style_type: 'css-list-style-type',
    css_list_style: 'css-list-style',
    css_margin_block_start_end: 'css-margin-block-start-end',
    css_margin_inline_block: 'css-margin-inline-block',
    css_margin_inline_start_end: 'css-margin-inline-start-end',
    css_margin_inline: 'css-margin-inline',
    css_margin: 'css-margin',
    css_max_block_size: 'css-max-block-size',
    css_max_height: 'css-max-height',
    css_max_width: 'css-max-width',
    css_min_height: 'css-min-height',
    css_min_inline_size: 'css-min-inline-size',
    css_min_width: 'css-min-width',
    css_mix_blend_mode: 'css-mix-blend-mode',
    css_object_fit: 'css-object-fit',
    css_object_position: 'css-object-position',
    css_opacity: 'css-opacity',
    css_outline_offset: 'css-outline-offset',
    css_outline: 'css-outline',
    css_overflow_wrap: 'css-overflow-wrap',
    css_overflow: 'css-overflow',
    css_padding_block_start_end: 'css-padding-block-start-end',
    css_padding_inline_block: 'css-padding-inline-block',
    css_padding_inline_start_end: 'css-padding-inline-start-end',
    css_padding: 'css-padding',
    css_position: 'css-position',
    css_tab_size: 'css-tab-size',
    css_table_layout: 'css-table-layout',
    css_text_align_last: 'css-text-align-last',
    css_text_align: 'css-text-align',
    css_text_decoration_color: 'css-text-decoration-color',
    css_text_decoration_thickness: 'css-text-decoration-thickness',
    css_text_decoration: 'css-text-decoration',
    css_text_emphasis_position: 'css-text-emphasis-position',
    css_text_emphasis: 'css-text-emphasis',
    css_text_indent: 'css-text-indent',
    css_text_overflow: 'css-text-overflow',
    css_text_shadow: 'css-text-shadow',
    css_text_transform: 'css-text-transform',
    css_text_underline_offset: 'css-text-underline-offset',
    css_transform: 'css-transform',
    css_vertical_align: 'css-vertical-align',
    css_visibility: 'css-visibility',
    css_white_space: 'css-white-space',
    css_width: 'css-width',
    css_word_break: 'css-word-break',
    css_writing_mode: 'css-writing-mode',
    css_z_index: 'css-z-index',
    html_abbr: 'html-abbr',
    html_address: 'html-address',
    html_align: 'html-align',
    html_anchor_links: 'html-anchor-links',
    html_aria_describedby: 'html-aria-describedby',
    html_aria_hidden: 'html-aria-hidden',
    html_aria_label: 'html-aria-label',
    html_aria_labelledby: 'html-aria-labelledby',
    html_aria_live: 'html-aria-live',
    html_audio: 'html-audio',
    html_background: 'html-background',
    html_base: 'html-base',
    html_blockquote: 'html-blockquote',
    html_body: 'html-body',
    html_button_reset: 'html-button-reset',
    html_button_submit: 'html-button-submit',
    html_code: 'html-code',
    html_del: 'html-del',
    html_dfn: 'html-dfn',
    html_dialog: 'html-dialog',
    html_dir: 'html-dir',
    html_div: 'html-div',
    html_doctype: 'html-doctype',
    html_form: 'html-form',
    html_h1_h6: 'html-h1-h6',
    html_height: 'html-height',
    html_image_maps: 'html-image-maps',
    html_input_checkbox: 'html-input-checkbox',
    html_input_hidden: 'html-input-hidden',
    html_input_radio: 'html-input-radio',
    html_input_reset: 'html-input-reset',
    html_input_submit: 'html-input-submit',
    html_input_text: 'html-input-text',
    html_lang: 'html-lang',
    html_link: 'html-link',
    html_lists: 'html-lists',
    html_loading_attribute: 'html-loading-attribute',
    html_mailto_links: 'html-mailto-links',
    html_marquee: 'html-marquee',
    html_meter: 'html-meter',
    html_object: 'html-object',
    html_p: 'html-p',
    html_picture: 'html-picture',
    html_pre: 'html-pre',
    html_progress: 'html-progress',
    html_required: 'html-required',
    html_role: 'html-role',
    html_rp: 'html-rp',
    html_rt: 'html-rt',
    html_ruby: 'html-ruby',
    html_select: 'html-select',
    html_semantics: 'html-semantics',
    html_small: 'html-small',
    html_span: 'html-span',
    html_srcset: 'html-srcset',
    html_strike: 'html-strike',
    html_strong: 'html-strong',
    html_style: 'html-style',
    html_svg: 'html-svg',
    html_table: 'html-table',
    html_target: 'html-target',
    html_textarea: 'html-textarea',
    html_valign: 'html-valign',
    html_video: 'html-video',
    html_wbr: 'html-wbr',
    html_width: 'html-width',
    image_avif: 'image-avif',
    image_base64: 'image-base64',
    image_bmp: 'image-bmp',
    image_gif: 'image-gif',
    image_ico: 'image-ico',
    image_jpg: 'image-jpg',
    image_png: 'image-png',
    image_svg: 'image-svg',
    image_webp: 'image-webp',
    unsupported: 'unsupported'
};
/**
 * @export
 */
export const EmailFeatureSupportStatusPercentageStatusEnum = {
    SUPPORTED: 'SUPPORTED',
    PARTIAL: 'PARTIAL',
    NOT_SUPPORTED: 'NOT_SUPPORTED',
    UNKNOWN: 'UNKNOWN'
};
/**
 * @export
 */
export const EmailThreadItemProjectionItemTypeEnum = {
    RECEIVED_EMAIL: 'RECEIVED_EMAIL',
    SENT_EMAIL: 'SENT_EMAIL'
};
/**
 * @export
 */
export const EmailValidationSubscriptionSubscriptionScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const EmailValidationSubscriptionPlanCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const EmergencyAddressPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const EmergencyAddressDtoPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const ErrorCodesDtoAppErrorCodesEnum = {
    I_001_UPGRADE_REQUIRED: 'I_001_UPGRADE_REQUIRED',
    W_404_ENTITY_NOT_FOUND: 'W_404_ENTITY_NOT_FOUND',
    W_404_USER_NOT_FOUND_FOR_ACCESS_LINK: 'W_404_USER_NOT_FOUND_FOR_ACCESS_LINK',
    W_404_USER_NOT_FOUND_FOR_PASSWORD: 'W_404_USER_NOT_FOUND_FOR_PASSWORD',
    W_409_USER_ALREADY_EXISTS: 'W_409_USER_ALREADY_EXISTS',
    W_404_USER_NOT_FOUND_FOR_PASSWORD_RESET: 'W_404_USER_NOT_FOUND_FOR_PASSWORD_RESET',
    W_400_BAD_REQUEST: 'W_400_BAD_REQUEST',
    W_401_UNAUTHORIZED: 'W_401_UNAUTHORIZED',
    W_401_CHALLENGE_INVALID: 'W_401_CHALLENGE_INVALID',
    W_401_MULTIPLE_ACCOUNTS: 'W_401_MULTIPLE_ACCOUNTS',
    W_403_FORBIDDEN: 'W_403_FORBIDDEN',
    W_409_CONFLICT: 'W_409_CONFLICT',
    W_409_LINK_ACCESS_BLOCKED: 'W_409_LINK_ACCESS_BLOCKED',
    W_429_RATE_LIMITED: 'W_429_RATE_LIMITED',
    W_429_SEND_BLOCK: 'W_429_SEND_BLOCK',
    W_429_ACCOUNT_FROZEN: 'W_429_ACCOUNT_FROZEN',
    E_001_UNEXPECTED_ERROR: 'E_001_UNEXPECTED_ERROR',
    E_400_BAD_REQUEST: 'E_400_BAD_REQUEST',
    E_500_INTERNAL_ERROR: 'E_500_INTERNAL_ERROR',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_VALIDATION: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_VALIDATION',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_CONNECTOR: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_CONNECTOR',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_AI: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_AI',
    W_429_SUBSCRIPTION_LIMIT_REACHED: 'W_429_SUBSCRIPTION_LIMIT_REACHED',
    W_429_SUBSCRIPTION_PAYMENT_FAILURES: 'W_429_SUBSCRIPTION_PAYMENT_FAILURES',
    W_429_SUBSCRIPTION_TRIAL_LIMIT: 'W_429_SUBSCRIPTION_TRIAL_LIMIT',
    W_429_SUBSCRIPTION_REQUIRED: 'W_429_SUBSCRIPTION_REQUIRED',
    W_429_SUBSCRIPTION_OUT_OF_DATE: 'W_429_SUBSCRIPTION_OUT_OF_DATE',
    W_429_SUBSCRIPTION_FREE_LIMIT: 'W_429_SUBSCRIPTION_FREE_LIMIT'
};
/**
 * @export
 */
export const ErrorResponseErrorCodeEnum = {
    I_001_UPGRADE_REQUIRED: 'I_001_UPGRADE_REQUIRED',
    W_404_ENTITY_NOT_FOUND: 'W_404_ENTITY_NOT_FOUND',
    W_404_USER_NOT_FOUND_FOR_ACCESS_LINK: 'W_404_USER_NOT_FOUND_FOR_ACCESS_LINK',
    W_404_USER_NOT_FOUND_FOR_PASSWORD: 'W_404_USER_NOT_FOUND_FOR_PASSWORD',
    W_409_USER_ALREADY_EXISTS: 'W_409_USER_ALREADY_EXISTS',
    W_404_USER_NOT_FOUND_FOR_PASSWORD_RESET: 'W_404_USER_NOT_FOUND_FOR_PASSWORD_RESET',
    W_400_BAD_REQUEST: 'W_400_BAD_REQUEST',
    W_401_UNAUTHORIZED: 'W_401_UNAUTHORIZED',
    W_401_CHALLENGE_INVALID: 'W_401_CHALLENGE_INVALID',
    W_401_MULTIPLE_ACCOUNTS: 'W_401_MULTIPLE_ACCOUNTS',
    W_403_FORBIDDEN: 'W_403_FORBIDDEN',
    W_409_CONFLICT: 'W_409_CONFLICT',
    W_409_LINK_ACCESS_BLOCKED: 'W_409_LINK_ACCESS_BLOCKED',
    W_429_RATE_LIMITED: 'W_429_RATE_LIMITED',
    W_429_SEND_BLOCK: 'W_429_SEND_BLOCK',
    W_429_ACCOUNT_FROZEN: 'W_429_ACCOUNT_FROZEN',
    E_001_UNEXPECTED_ERROR: 'E_001_UNEXPECTED_ERROR',
    E_400_BAD_REQUEST: 'E_400_BAD_REQUEST',
    E_500_INTERNAL_ERROR: 'E_500_INTERNAL_ERROR',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_VALIDATION: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_VALIDATION',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_CONNECTOR: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_CONNECTOR',
    W_429_SUBSCRIPTION_ADDON_REQUIRED_AI: 'W_429_SUBSCRIPTION_ADDON_REQUIRED_AI',
    W_429_SUBSCRIPTION_LIMIT_REACHED: 'W_429_SUBSCRIPTION_LIMIT_REACHED',
    W_429_SUBSCRIPTION_PAYMENT_FAILURES: 'W_429_SUBSCRIPTION_PAYMENT_FAILURES',
    W_429_SUBSCRIPTION_TRIAL_LIMIT: 'W_429_SUBSCRIPTION_TRIAL_LIMIT',
    W_429_SUBSCRIPTION_REQUIRED: 'W_429_SUBSCRIPTION_REQUIRED',
    W_429_SUBSCRIPTION_OUT_OF_DATE: 'W_429_SUBSCRIPTION_OUT_OF_DATE',
    W_429_SUBSCRIPTION_FREE_LIMIT: 'W_429_SUBSCRIPTION_FREE_LIMIT'
};
/**
 * @export
 */
export const ExportOptionsOutputFormatEnum = {
    DEFAULT: 'CSV_DEFAULT',
    EXCEL: 'CSV_EXCEL'
};
/**
 * @export
 */
export const GenerateBimiRecordOptionsVersionEnum = {
    BIMI1: 'BIMI1'
};
/**
 * @export
 */
export const GenerateBimiRecordResultsTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsVersionEnum = {
    DMARC1: 'DMARC1'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsPolicyEnum = {
    NONE: 'NONE',
    QUARANTINE: 'QUARANTINE',
    REJECT: 'REJECT'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsSubdomainPolicyEnum = {
    NONE: 'NONE',
    QUARANTINE: 'QUARANTINE',
    REJECT: 'REJECT'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsReportFormatEnum = {
    AFRF: 'AFRF'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsAdkimEnum = {
    STRICT: 'STRICT',
    RELAXED: 'RELAXED'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsAspfEnum = {
    STRICT: 'STRICT',
    RELAXED: 'RELAXED'
};
/**
 * @export
 */
export const GenerateDmarcRecordOptionsFoEnum = {
    _0: 'FO_0',
    _1: 'FO_1',
    D: 'FO_D',
    S: 'FO_S'
};
/**
 * @export
 */
export const GenerateDmarcRecordResultsTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const GenerateMtaStsRecordOptionsVersionEnum = {
    STSv1: 'STSv1'
};
/**
 * @export
 */
export const GenerateMtaStsRecordOptionsModeEnum = {
    TESTING: 'TESTING',
    ENFORCE: 'ENFORCE',
    NONE: 'NONE'
};
/**
 * @export
 */
export const GenerateMtaStsRecordResultsTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const GenerateTlsReportingRecordOptionsVersionEnum = {
    TLSRPTv1: 'TLSRPTv1'
};
/**
 * @export
 */
export const GenerateTlsReportingRecordResultsTypeEnum = {
    A: 'A',
    NS: 'NS',
    MD: 'MD',
    MF: 'MF',
    CNAME: 'CNAME',
    SOA: 'SOA',
    MB: 'MB',
    MG: 'MG',
    MR: 'MR',
    NULL: 'NULL',
    WKS: 'WKS',
    PTR: 'PTR',
    HINFO: 'HINFO',
    MINFO: 'MINFO',
    MX: 'MX',
    TXT: 'TXT',
    RP: 'RP',
    AFSDB: 'AFSDB',
    X25: 'X25',
    ISDN: 'ISDN',
    RT: 'RT',
    NSAP: 'NSAP',
    NSAP_PTR: 'NSAP_PTR',
    SIG: 'SIG',
    KEY: 'KEY',
    PX: 'PX',
    GPOS: 'GPOS',
    AAAA: 'AAAA',
    LOC: 'LOC',
    NXT: 'NXT',
    EID: 'EID',
    NIMLOC: 'NIMLOC',
    SRV: 'SRV',
    ATMA: 'ATMA',
    NAPTR: 'NAPTR',
    KX: 'KX',
    CERT: 'CERT',
    A6: 'A6',
    DNAME: 'DNAME',
    SINK: 'SINK',
    OPT: 'OPT',
    APL: 'APL',
    DS: 'DS',
    SSHFP: 'SSHFP',
    IPSECKEY: 'IPSECKEY',
    RRSIG: 'RRSIG',
    NSEC: 'NSEC',
    DNSKEY: 'DNSKEY',
    DHCID: 'DHCID',
    NSEC3: 'NSEC3',
    NSEC3PARAM: 'NSEC3PARAM',
    TLSA: 'TLSA',
    SMIMEA: 'SMIMEA',
    HIP: 'HIP',
    NINFO: 'NINFO',
    RKEY: 'RKEY',
    TALINK: 'TALINK',
    CDS: 'CDS',
    CDNSKEY: 'CDNSKEY',
    OPENPGPKEY: 'OPENPGPKEY',
    CSYNC: 'CSYNC',
    ZONEMD: 'ZONEMD',
    SVCB: 'SVCB',
    HTTPS: 'HTTPS',
    SPF: 'SPF',
    UINFO: 'UINFO',
    UID: 'UID',
    GID: 'GID',
    UNSPEC: 'UNSPEC',
    NID: 'NID',
    L32: 'L32',
    L64: 'L64',
    LP: 'LP',
    EUI48: 'EUI48',
    EUI64: 'EUI64',
    TKEY: 'TKEY',
    TSIG: 'TSIG',
    IXFR: 'IXFR',
    AXFR: 'AXFR',
    MAILB: 'MAILB',
    MAILA: 'MAILA',
    ANY: 'ANY',
    URI: 'URI',
    CAA: 'CAA',
    AVC: 'AVC',
    DOA: 'DOA',
    AMTRELAY: 'AMTRELAY',
    TA: 'TA',
    DLV: 'DLV'
};
/**
 * @export
 */
export const HasOnboardedFeaturesHasOnboardedFeaturesEnum = {
    DASHBOARD: 'DASHBOARD',
    INTEGRATIONS: 'INTEGRATIONS',
    INBOXES: 'INBOXES',
    INBOXES_CREATE: 'INBOXES_CREATE',
    ORGANIZATIONS: 'ORGANIZATIONS',
    ORGANIZATIONS_CREATE: 'ORGANIZATIONS_CREATE',
    FORWARDING: 'FORWARDING',
    ALIASES: 'ALIASES',
    WEBHOOKS: 'WEBHOOKS'
};
/**
 * @export
 */
export const ImageIssueSeverityEnum = {
    Warning: 'Warning',
    Error: 'Error'
};
/**
 * @export
 */
export const ImapFlagOperationOptionsFlagOperationEnum = {
    SET_FLAGS: 'SET_FLAGS',
    ADD_FLAGS: 'ADD_FLAGS',
    REMOVE_FLAGS: 'REMOVE_FLAGS'
};
/**
 * @export
 */
export const ImapServerStatusOptionsStatusItemsEnum = {
    MESSAGES: 'MESSAGES',
    RECENT: 'RECENT',
    UIDNEXT: 'UIDNEXT',
    UIDVALIDITY: 'UIDVALIDITY',
    UNSEEN: 'UNSEEN',
    APPENDLIMIT: 'APPENDLIMIT'
};
/**
 * @export
 */
export const InboxDtoInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const InboxDtoFunctionsAsEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const InboxForwarderDtoFieldEnum = {
    RECIPIENTS: 'RECIPIENTS',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
    ATTACHMENTS: 'ATTACHMENTS'
};
/**
 * @export
 */
export const InboxForwarderEventDtoStatusEnum = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};
/**
 * @export
 */
export const InboxForwarderEventProjectionStatusEnum = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};
/**
 * @export
 */
export const InboxPreviewInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const InboxPreviewFunctionsAsEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const InboxReplierDtoFieldEnum = {
    RECIPIENTS: 'RECIPIENTS',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
    ATTACHMENTS: 'ATTACHMENTS'
};
/**
 * @export
 */
export const InboxReplierEventProjectionStatusEnum = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};
/**
 * @export
 */
export const InboxRulesetDtoScopeEnum = {
    RECEIVING_EMAILS: 'RECEIVING_EMAILS',
    SENDING_EMAILS: 'SENDING_EMAILS'
};
/**
 * @export
 */
export const InboxRulesetDtoActionEnum = {
    BLOCK: 'BLOCK',
    ALLOW: 'ALLOW',
    FILTER_REMOVE: 'FILTER_REMOVE'
};
/**
 * @export
 */
export const InboxRulesetDtoHandlerEnum = {
    EXCEPTION: 'EXCEPTION'
};
/**
 * @export
 */
export const InternalPhoneNumberDtoPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const InviteOrganizationUserOptionsUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const LinkIssueSeverityEnum = {
    Warning: 'Warning',
    Error: 'Error'
};
/**
 * @export
 */
export const MatchOptionFieldEnum = {
    SUBJECT: 'SUBJECT',
    TO: 'TO',
    BCC: 'BCC',
    CC: 'CC',
    FROM: 'FROM',
    HEADERS: 'HEADERS'
};
/**
 * @export
 */
export const MatchOptionShouldEnum = {
    MATCH: 'MATCH',
    CONTAIN: 'CONTAIN',
    EQUAL: 'EQUAL'
};
/**
 * @export
 */
export const MonthlyUsageChartsMonthEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
};
/**
 * @export
 */
export const NotificationNotificationTypeEnum = {
    TRIAL_OVER: 'TRIAL_OVER',
    TRIAL_HALF_OVER: 'TRIAL_HALF_OVER',
    NOT_ACTIVE: 'NOT_ACTIVE',
    PLAN_LIMIT: 'PLAN_LIMIT',
    RATE_LIMIT: 'RATE_LIMIT',
    WEBHOOK_FAILURE: 'WEBHOOK_FAILURE',
    SUBSCRIPTION_CANCELLED_BY_USER: 'SUBSCRIPTION_CANCELLED_BY_USER',
    NEW_SUBSCRIPTION: 'NEW_SUBSCRIPTION',
    FOLLOW_UP: 'FOLLOW_UP',
    SPAM_ACTIVITY: 'SPAM_ACTIVITY',
    BOUNCE_WARNING: 'BOUNCE_WARNING',
    FREEZE_WARNING: 'FREEZE_WARNING',
    THAWED: 'THAWED',
    USER_FROZEN: 'USER_FROZEN',
    USER_PURGED: 'USER_PURGED',
    CREATED_DOMAIN: 'CREATED_DOMAIN',
    DOMAIN_PURGED: 'DOMAIN_PURGED',
    ACCOUNT_EMAIL_CHANGED: 'ACCOUNT_EMAIL_CHANGED',
    STRIPE_PAYMENT_EVENT: 'STRIPE_PAYMENT_EVENT',
    DOMAIN_VERIFIED: 'DOMAIN_VERIFIED',
    WELCOME: 'WELCOME',
    NEW_ORGANIZATION: 'NEW_ORGANIZATION',
    SEND_TEST_INBOX_EMAIL: 'SEND_TEST_INBOX_EMAIL',
    NEW_ZAPIER_CONNECTION: 'NEW_ZAPIER_CONNECTION',
    SPANK: 'SPANK',
    VERIFY_ALIAS: 'VERIFY_ALIAS',
    PAYMENT_FAILURE: 'PAYMENT_FAILURE',
    EXPIRED_INBOX: 'EXPIRED_INBOX'
};
/**
 * @export
 */
export const NotificationMetricsStatusEnum = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    INFO: 'INFO'
};
/**
 * @export
 */
export const NotificationMetricsStateEnum = {
    OKAY: 'OKAY',
    HAS_NOTIFICATIONS: 'HAS_NOTIFICATIONS'
};
/**
 * @export
 */
export const NotificationProjectionNotificationTypeEnum = {
    TRIAL_OVER: 'TRIAL_OVER',
    TRIAL_HALF_OVER: 'TRIAL_HALF_OVER',
    NOT_ACTIVE: 'NOT_ACTIVE',
    PLAN_LIMIT: 'PLAN_LIMIT',
    RATE_LIMIT: 'RATE_LIMIT',
    WEBHOOK_FAILURE: 'WEBHOOK_FAILURE',
    SUBSCRIPTION_CANCELLED_BY_USER: 'SUBSCRIPTION_CANCELLED_BY_USER',
    NEW_SUBSCRIPTION: 'NEW_SUBSCRIPTION',
    FOLLOW_UP: 'FOLLOW_UP',
    SPAM_ACTIVITY: 'SPAM_ACTIVITY',
    BOUNCE_WARNING: 'BOUNCE_WARNING',
    FREEZE_WARNING: 'FREEZE_WARNING',
    THAWED: 'THAWED',
    USER_FROZEN: 'USER_FROZEN',
    USER_PURGED: 'USER_PURGED',
    CREATED_DOMAIN: 'CREATED_DOMAIN',
    DOMAIN_PURGED: 'DOMAIN_PURGED',
    ACCOUNT_EMAIL_CHANGED: 'ACCOUNT_EMAIL_CHANGED',
    STRIPE_PAYMENT_EVENT: 'STRIPE_PAYMENT_EVENT',
    DOMAIN_VERIFIED: 'DOMAIN_VERIFIED',
    WELCOME: 'WELCOME',
    NEW_ORGANIZATION: 'NEW_ORGANIZATION',
    SEND_TEST_INBOX_EMAIL: 'SEND_TEST_INBOX_EMAIL',
    NEW_ZAPIER_CONNECTION: 'NEW_ZAPIER_CONNECTION',
    SPANK: 'SPANK',
    VERIFY_ALIAS: 'VERIFY_ALIAS',
    PAYMENT_FAILURE: 'PAYMENT_FAILURE',
    EXPIRED_INBOX: 'EXPIRED_INBOX'
};
/**
 * @export
 */
export const OrganizationInboxProjectionInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const OrganizationInboxProjectionFunctionsAsEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const OrganizationSamlSettingsConfigDigestAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const OrganizationSamlSettingsConfigSignatureAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const OrganizationSamlSettingsConfigProtocolEnum = {
    HTTP: 'HTTP',
    HTTPS: 'HTTPS'
};
/**
 * @export
 */
export const OrganizationSamlSettingsConfigAuthnRequestBindingEnum = {
    REDIRECT: 'HTTP_REDIRECT',
    POST: 'HTTP_POST'
};
/**
 * @export
 */
export const OrganizationUserProjectionVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const OrganizationUserProjectionUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const PhoneNumberDtoPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const PhoneNumberProjectionPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const PhonePlanAvailabilityItemPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const PhonePlanAvailabilityItemAvailabilityStatusEnum = {
    AVAILABLE: 'AVAILABLE',
    NON_MATCHING_SUBSCRIPTION_CURRENCY: 'NON_MATCHING_SUBSCRIPTION_CURRENCY',
    NON_MATCHING_SUBSCRIPTION_TYPE: 'NON_MATCHING_SUBSCRIPTION_TYPE',
    ALREADY_ASSIGNED: 'ALREADY_ASSIGNED'
};
/**
 * @export
 */
export const PhonePlanDtoPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const PlanAddonsSupportedAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const PlanConfigSubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const PlanDisplayCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const PlanDisplayScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const PlanDisplaySubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const PlanDisplaysDefaultCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const PlanDisplaysDefaultScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const PlanDisplaysRecommendedTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const PlanDisplaysCurrenciesEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const PlanDisplaysSchedulesEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const PlanDisplaysTypesEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const PlanDisplaysPaymentMethodsEnum = {
    ALIPAY: 'ALIPAY',
    CARD: 'CARD',
    SEPA_DEBIT: 'SEPA_DEBIT'
};
/**
 * @export
 */
export const ProductBatchedAddonPlanDisplaysCurrenciesEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const ProductBatchedAddonPlanDisplaysSchedulesEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const ProductBatchedAddonPlanDisplaysRequiredSubscriptionTypesEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const ProductPhoneNumberDisplaysCurrenciesEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const ProductPhoneNumberDisplaysSchedulesEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const ProductPhonePlanDisplaysCurrenciesEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const ProductPhonePlanDisplaysSchedulesEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const ProductUserPlanDisplaysCurrenciesEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const ProductUserPlanDisplaysSchedulesEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const ProductUserPlanDisplaysRequiredSubscriptionTypesEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const ProviderSettingsMailProviderEnum = {
    GOOGLE: 'GOOGLE',
    MICROSOFT: 'MICROSOFT'
};
/**
 * @export
 */
export const QuoteDtoQuoteStatusEnum = {
    OPEN: 'OPEN',
    ACCEPTED: 'ACCEPTED',
    CANCELED: 'CANCELED',
    FINALIZED: 'FINALIZED',
    DRAFT: 'DRAFT'
};
/**
 * @export
 */
export const QuoteParamsTaxIdsEnum = {
    AE_TRN: 'AE_TRN',
    AU_ABN: 'AU_ABN',
    AU_ARN: 'AU_ARN',
    BR_CNPJ: 'BR_CNPJ',
    BR_CPF: 'BR_CPF',
    CA_BN: 'CA_BN',
    CA_GST_HST: 'CA_GST_HST',
    CA_PST_BC: 'CA_PST_BC',
    CA_PST_MB: 'CA_PST_MB',
    CA_PST_SK: 'CA_PST_SK',
    CA_QST: 'CA_QST',
    CH_VAT: 'CH_VAT',
    CL_TIN: 'CL_TIN',
    ES_CIF: 'ES_CIF',
    EU_VAT: 'EU_VAT',
    GB_VAT: 'GB_VAT',
    GE_VAT: 'GE_VAT',
    HK_BR: 'HK_BR',
    ID_NPWP: 'ID_NPWP',
    IL_VAT: 'IL_VAT',
    IN_GST: 'IN_GST',
    IS_VAT: 'IS_VAT',
    JP_CN: 'JP_CN',
    JP_RN: 'JP_RN',
    KR_BRN: 'KR_BRN',
    LI_UID: 'LI_UID',
    MX_RFC: 'MX_RFC',
    MY_FRP: 'MY_FRP',
    MY_ITN: 'MY_ITN',
    MY_SST: 'MY_SST',
    NO_VAT: 'NO_VAT',
    NZ_GST: 'NZ_GST',
    RU_INN: 'RU_INN',
    RU_KPP: 'RU_KPP',
    SA_VAT: 'SA_VAT',
    SG_GST: 'SG_GST',
    SG_UEN: 'SG_UEN',
    TH_VAT: 'TH_VAT',
    TW_VAT: 'TW_VAT',
    UA_VAT: 'UA_VAT',
    US_EIN: 'US_EIN',
    ZA_VAT: 'ZA_VAT'
};
/**
 * @export
 */
export const ReplyToAliasEmailOptionsSendStrategyEnum = {
    SINGLE_MESSAGE: 'SINGLE_MESSAGE'
};
/**
 * @export
 */
export const ReplyToEmailOptionsSendStrategyEnum = {
    SINGLE_MESSAGE: 'SINGLE_MESSAGE'
};
/**
 * @export
 */
export const ReputationMetricsStatusEnum = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    INFO: 'INFO'
};
/**
 * @export
 */
export const ReputationMetricsStateEnum = {
    OKAY: 'OKAY',
    HAS_BOUNCES: 'HAS_BOUNCES',
    IS_BLOCKED: 'IS_BLOCKED'
};
/**
 * @export
 */
export const ScheduledJobStatusEnum = {
    SUBMITTED: 'SUBMITTED',
    COMPLETED: 'COMPLETED',
    ABORTED: 'ABORTED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED'
};
/**
 * @export
 */
export const ScheduledJobDtoStatusEnum = {
    SUBMITTED: 'SUBMITTED',
    COMPLETED: 'COMPLETED',
    ABORTED: 'ABORTED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED'
};
/**
 * @export
 */
export const SearchEmailsOptionsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const SearchInboxesOptionsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const SearchInboxesOptionsInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const SearchInboxesOptionsInboxFunctionEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const SeedConnectorEventsOptionsEventTypeEnum = {
    SEND: 'SEND',
    SYNC: 'SYNC'
};
/**
 * @export
 */
export const SeedConnectorEventsOptionsStatusEnum = {
    SUCCESS: 'SUCCESS',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SUBSCRIPTION_ERROR: 'SUBSCRIPTION_ERROR',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    NOT_FOUND: 'NOT_FOUND'
};
/**
 * @export
 */
export const SeedDomainOptionsDomainTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_DOMAIN: 'SMTP_DOMAIN'
};
/**
 * @export
 */
export const SeedEmailThreadItemItemTypeEnum = {
    RECEIVED_EMAIL: 'RECEIVED_EMAIL',
    SENT_EMAIL: 'SENT_EMAIL'
};
/**
 * @export
 */
export const SeedForwarderEventsOptionsStatusEnum = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};
/**
 * @export
 */
export const SeedInboxOptionsSeedTypeEnum = {
    MINIMAL: 'EMAIL_MINIMAL',
    FULL: 'EMAIL_FULL'
};
/**
 * @export
 */
export const SeedOrganizationUserVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const SeedOrganizationUserUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const SeedOrganizationUserOptionsUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const SeedOrganizationUserOptionsVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const SeedPhoneNumbersOptionsCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const SeedSeriesOptionsSeriesTypeEnum = {
    USAGE_RECORD: 'USAGE_RECORD',
    USAGE_RECORD_UPDATE_RESULT: 'USAGE_RECORD_UPDATE_RESULT',
    EVENT_AGGREGATE: 'EVENT_AGGREGATE'
};
/**
 * @export
 */
export const SendEmailOptionsSendStrategyEnum = {
    SINGLE_MESSAGE: 'SINGLE_MESSAGE'
};
/**
 * @export
 */
export const SendEmailOptionsValidateEmailAddressesEnum = {
    VALIDATE_FILTER_REMOVE_INVALID: 'VALIDATE_FILTER_REMOVE_INVALID',
    VALIDATE_ERROR_IF_INVALID: 'VALIDATE_ERROR_IF_INVALID',
    NO_VALIDATION: 'NO_VALIDATION'
};
/**
 * @export
 */
export const SmsMatchOptionFieldEnum = {
    BODY: 'BODY',
    FROM: 'FROM'
};
/**
 * @export
 */
export const SmsMatchOptionShouldEnum = {
    MATCH: 'MATCH',
    CONTAIN: 'CONTAIN',
    EQUAL: 'EQUAL'
};
/**
 * @export
 */
export const SpellingIssueSeverityEnum = {
    Warning: 'Warning',
    Error: 'Error'
};
/**
 * @export
 */
export const StatsConstantsMonthsEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
};
/**
 * @export
 */
export const StatsConstantsCurrentMonthEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
};
/**
 * @export
 */
export const StripeBatchedAddonPlanProductCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const StripeBatchedAddonPlanProductScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const StripeBatchedAddonPlanProductSupportedSubscriptionTypesEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const StripePhoneNumberProductCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const StripePhoneNumberProductScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const StripePhoneNumberProductPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const StripePhonePlanProductItemCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const StripePhonePlanProductItemScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const StripePhonePlanProductItemPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const StripeProductScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const StripeProductCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const StripeUserPlanProductCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const StripeUserPlanProductScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const StripeUserPlanProductSupportedSubscriptionTypesEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const StripeWebhookEventEntityEventTypeEnum = {
    customerDeleted: 'customerDeleted',
    setupIntentSucceeded: 'setupIntentSucceeded',
    paymentIntentSucceeded: 'paymentIntentSucceeded',
    invoicePaymentSucceeded: 'invoicePaymentSucceeded',
    invoicePaid: 'invoicePaid',
    invoiceVoided: 'invoiceVoided',
    invoiceUncollectible: 'invoiceUncollectible',
    customerSubscriptionCreated: 'customerSubscriptionCreated',
    customerSubscriptionDeleted: 'customerSubscriptionDeleted',
    customerSubscriptionUpdated: 'customerSubscriptionUpdated',
    chargeFailed: 'chargeFailed',
    paymentIntentPaymentFailed: 'paymentIntentPaymentFailed',
    invoicePaymentFailed: 'invoicePaymentFailed',
    radarEarlyFraudWarningCreated: 'radarEarlyFraudWarningCreated',
    chargePending: 'chargePending',
    chargeSucceeded: 'chargeSucceeded',
    chargeDisputed: 'chargeDisputed',
    quoteCreated: 'quoteCreated',
    quoteAccepted: 'quoteAccepted',
    quoteFinalized: 'quoteFinalized',
    quoteCanceled: 'quoteCanceled'
};
/**
 * @export
 */
export const StripeWebhookResponseEventTypeEnum = {
    customerDeleted: 'customerDeleted',
    setupIntentSucceeded: 'setupIntentSucceeded',
    paymentIntentSucceeded: 'paymentIntentSucceeded',
    invoicePaymentSucceeded: 'invoicePaymentSucceeded',
    invoicePaid: 'invoicePaid',
    invoiceVoided: 'invoiceVoided',
    invoiceUncollectible: 'invoiceUncollectible',
    customerSubscriptionCreated: 'customerSubscriptionCreated',
    customerSubscriptionDeleted: 'customerSubscriptionDeleted',
    customerSubscriptionUpdated: 'customerSubscriptionUpdated',
    chargeFailed: 'chargeFailed',
    paymentIntentPaymentFailed: 'paymentIntentPaymentFailed',
    invoicePaymentFailed: 'invoicePaymentFailed',
    radarEarlyFraudWarningCreated: 'radarEarlyFraudWarningCreated',
    chargePending: 'chargePending',
    chargeSucceeded: 'chargeSucceeded',
    chargeDisputed: 'chargeDisputed',
    quoteCreated: 'quoteCreated',
    quoteAccepted: 'quoteAccepted',
    quoteFinalized: 'quoteFinalized',
    quoteCanceled: 'quoteCanceled'
};
/**
 * @export
 */
export const SubscriptionDtoCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const SubscriptionDtoSubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const SubscriptionDtoSubscriptionScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const SubscriptionDtoSubscriptionStatusEnum = {
    incomplete_expired: 'incomplete_expired',
    past_due: 'past_due',
    canceled: 'canceled',
    unpaid: 'unpaid',
    paused: 'paused',
    incomplete: 'incomplete',
    trialing: 'trialing',
    active: 'active'
};
/**
 * @export
 */
export const SubscriptionMetricsStatusEnum = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    INFO: 'INFO'
};
/**
 * @export
 */
export const SubscriptionMetricsStateEnum = {
    FREE_ACCOUNT: 'FREE_ACCOUNT',
    BAD_STATUS: 'BAD_STATUS',
    TRIAL_ACCOUNT: 'TRIAL_ACCOUNT',
    PAYMENT_ERRORS: 'PAYMENT_ERRORS',
    PENDING_CHARGE: 'PENDING_CHARGE',
    MISSING_ADDONS: 'MISSING_ADDONS',
    OKAY: 'OKAY'
};
/**
 * @export
 */
export const SubscriptionMetricsMissingAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const SubscriptionMetricsSubscriptionStatusEnum = {
    incomplete_expired: 'incomplete_expired',
    past_due: 'past_due',
    canceled: 'canceled',
    unpaid: 'unpaid',
    paused: 'paused',
    incomplete: 'incomplete',
    trialing: 'trialing',
    active: 'active'
};
/**
 * @export
 */
export const SubscriptionSupportDtoSupportedAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const SubscriptionSupportDtoDisabledAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const TemplateVariableVariableTypeEnum = {
    STRING: 'STRING'
};
/**
 * @export
 */
export const UpdateChallengeOptionsStatusEnum = {
    PENDING: 'PENDING',
    VERIFIED: 'VERIFIED',
    EXPIRED: 'EXPIRED',
    CONSUMED: 'CONSUMED'
};
/**
 * @export
 */
export const UpdateInboxReplierOptionsFieldEnum = {
    RECIPIENTS: 'RECIPIENTS',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
    ATTACHMENTS: 'ATTACHMENTS'
};
/**
 * @export
 */
export const UpdateOrganizationSamlSettingsOptionsSignatureAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const UpdateOrganizationSamlSettingsOptionsDigestAlgorithmEnum = {
    SHA1: 'SHA1',
    SHA256: 'SHA256',
    SHA512: 'SHA512'
};
/**
 * @export
 */
export const UpdateOrganizationSamlSettingsOptionsProtocolEnum = {
    HTTP: 'HTTP',
    HTTPS: 'HTTPS'
};
/**
 * @export
 */
export const UpdateOrganizationSamlSettingsOptionsAuthnRequestBindingEnum = {
    REDIRECT: 'HTTP_REDIRECT',
    POST: 'HTTP_POST'
};
/**
 * @export
 */
export const UpdateOrganizationUserOptionsUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const UsageRecordUsageRecordTypeEnum = {
    EMAIL_VERIFICATION_REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    INBOUND_SMS: 'INBOUND_SMS',
    OUTBOUND_SMS: 'OUTBOUND_SMS',
    INBOX_CONNECTOR_SYNC: 'INBOX_CONNECTOR_SYNC',
    INBOX_CONNECTOR_SEND: 'INBOX_CONNECTOR_SEND',
    EMAIL_PLAN_INBOUND: 'EMAIL_PLAN_INBOUND',
    EMAIL_PLAN_OUTBOUND: 'EMAIL_PLAN_OUTBOUND',
    AI_TOKENS: 'AI_TOKENS',
    INBOX_CREATE: 'INBOX_CREATE',
    GUEST_USER_CREATE: 'GUEST_USER_CREATE',
    GUEST_USER_MAINTAIN: 'GUEST_USER_MAINTAIN'
};
/**
 * @export
 */
export const UserUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const UserVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const UserAddonsDtoAddonsEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const UserDtoUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const UserDtoVerifiedEnum = {
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};
/**
 * @export
 */
export const UserInfoDtoAccountStateEnum = {
    FROZEN: 'FROZEN',
    ACTIVE: 'ACTIVE'
};
/**
 * @export
 */
export const UserInfoDtoSubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const UserInfoDtoAccountTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
/**
 * @export
 */
export const WaitForConditionsCountTypeEnum = {
    EXACTLY: 'EXACTLY',
    ATLEAST: 'ATLEAST'
};
/**
 * @export
 */
export const WaitForConditionsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const WaitForSingleSmsOptionsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const WaitForSmsConditionsCountTypeEnum = {
    EXACTLY: 'EXACTLY',
    ATLEAST: 'ATLEAST'
};
/**
 * @export
 */
export const WaitForSmsConditionsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const WebhookBouncePayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookBounceRecipientPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookDeliveryStatusPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookDtoMethodEnum = {
    POST: 'POST',
    DELETE: 'DELETE',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
    TRACE: 'TRACE'
};
/**
 * @export
 */
export const WebhookDtoEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookDtoHealthStatusEnum = {
    HEALTHY: 'HEALTHY',
    UNHEALTHY: 'UNHEALTHY'
};
/**
 * @export
 */
export const WebhookEmailOpenedPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookEmailReadPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookEndpointProjectionHealthEnum = {
    HEALTHY: 'HEALTHY',
    UNHEALTHY: 'UNHEALTHY'
};
/**
 * @export
 */
export const WebhookNewAttachmentPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookNewContactPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookNewEmailPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookNewSmsPayloadEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookProjectionEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookProjectionHealthStatusEnum = {
    HEALTHY: 'HEALTHY',
    UNHEALTHY: 'UNHEALTHY'
};
/**
 * @export
 */
export const WebhookResultDtoHttpMethodEnum = {
    POST: 'POST',
    DELETE: 'DELETE',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
    TRACE: 'TRACE'
};
/**
 * @export
 */
export const WebhookResultDtoWebhookEventEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookResultDtoResultTypeEnum = {
    BAD_RESPONSE: 'BAD_RESPONSE',
    EXCEPTION: 'EXCEPTION',
    SUCCESS: 'SUCCESS',
    REDRIVEN: 'REDRIVEN'
};
/**
 * @export
 */
export const WebhookSeedItemEventNameEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const WebhookSeedItemHealthStatusEnum = {
    HEALTHY: 'HEALTHY',
    UNHEALTHY: 'UNHEALTHY'
};
/**
 * @export
 */
export const WebhookTestRequestMethodEnum = {
    POST: 'POST',
    DELETE: 'DELETE',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
    TRACE: 'TRACE'
};
